// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2E7KK","quickLinks":"styles_quickLinks__1LKpI","mainContent":"styles_mainContent__3Y5LJ"};